import { combineReducers } from "redux";
import productDetailsReducer from "./productDetails";
import userReducer from "./user";
import loaderReducer from "./loaders";
import productsReducer from "./products";

export default combineReducers({
    productDetails: productDetailsReducer,
    products: productsReducer,
    userDetails:userReducer,
    loaderDetail:loaderReducer
  });